import { useEffect, useState } from "react";
import { resolveWaveAgentIconUrl } from "../../services/waveAgentIcon";

type Props = {
  name?: string | null;
  emoji?: string | null;
  iconS3Key?: string | null;
  size?: number;
  className?: string;
};

export function WaveAgentAvatar({
  name,
  emoji,
  iconS3Key,
  size = 28,
  className = "",
}: Props) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const fallback = emoji?.trim() || "🤖";

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const url = await resolveWaveAgentIconUrl(iconS3Key);
      if (!cancelled) setImageUrl(url);
    })();
    return () => {
      cancelled = true;
    };
  }, [iconS3Key]);

  const title = name?.trim() || undefined;
  const cls = `wave-agent-avatar${className ? ` ${className}` : ""}`;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={cls}
        style={{ width: size, height: size }}
        title={title}
      />
    );
  }

  return (
    <span
      className={`${cls} wave-agent-avatar--emoji`}
      style={{ width: size, height: size, fontSize: size * 0.55 }}
      aria-hidden
      title={title}
    >
      {fallback}
    </span>
  );
}
